import { Component, input, signal } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { Rubric } from '@mira-avant/mtlibs';
import { RubricService } from '../../../../services/rubric.service';
import {
	DropdownControlComponent,
	DropdownOption,
} from '../../../controls/standard/dropdown-control/dropdown-control.component';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';

@Component({
	selector: 'app-rubric-dropdown-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, DropdownControlComponent],
	templateUrl: './rubric-dropdown-field.component.html',
	styleUrl: './rubric-dropdown-field.component.scss',
})
export class RubricDropdownFieldComponent extends BaseFieldComponent {
	// Input as signal
	readonly multiple = input<boolean>(false);

	// Reactive options
	readonly options = signal<DropdownOption[]>([]);

	public static override validators: ValidatorFn[] = [Validators.required];

	constructor(private rubricService: RubricService) {
		super();

		// Subscribe to rubrics observable and update signal
		this.rubricService.rubrics$.subscribe(rubrics => {
			this.options.set(
				rubrics.map((rubric: Rubric) => ({
					value: rubric.code,
					label: rubric.label,
				}))
			);
		});

		// Initial fetch (fire-and-forget, errors logged only)
		this.rubricService.getRubrics$().catch(error => {
			console.error('Error fetching rubrics:', error);
			this.options.set([]);
		});
	}
}
